// Authentication
export const AUTH_IDENTIFY_REQUEST = "AUTH_IDENTIFY_REQUEST";
export const AUTH_IDENTIFY_SUCCESS = "AUTH_IDENTIFY_SUCCESS";
export const AUTH_IDENTIFY_FAILURE = "AUTH_IDENTIFY_FAILURE";

// Editor
export const EDITOR_SET_DISPLAY_WIDTH = "EDITOR_SET_DISPLAY_WIDTH";
export const EDITOR_TOGGLE_BREAKDOWN = "EDITOR_TOGGLE_BREAKDOWN";
export const EDITOR_OPEN_BREAKDOWN = "EDITOR_OPEN_BREAKDOWN";

export const EDITOR_SWAP_MODULES = "EDITOR_SWITCH_MODULES";
export const EDITOR_SELECT_MODULE = "EDITOR_SELECT_MODULE";
export const EDITOR_REMOVE_SELECTED_MODULE = "EDITOR_REMOVE_SELECTED_MODULE";

export const EDITOR_UPDATE_MODULE_FIELD_VALUE =
  "EDITOR_UPDATE_MODULE_FIELD_VALUE";
export const EDITOR_UPDATE_NAME_VALUE = "EDITOR_UPDATE_NAME_VALUE";
export const EDITOR_UPDATE_SUBJECT_VALUE = "EDITOR_UPDATE_SUBJECT_VALUE";
export const EDITOR_UPDATE_TRANSLATION_VARIATION =
  "EDITOR_UPDATE_TRANSLATION_VARIATION";

export const EDITOR_INSERT_MODULE_REQUEST = "EDITOR_INSERT_MODULE_REQUEST";
export const EDITOR_INSERT_MODULE_SUCCESS = "EDITOR_INSERT_MODULE_SUCCESS";
export const EDITOR_INSERT_MODULE_FAILURE = "EDITOR_INSERT_MODULE_FAILURE";

export const EMAIL_REQUEST = "EMAIL_REQUEST";
export const EMAIL_SUCCESS = "EMAIL_SUCCESS";
export const EMAIL_FAILURE = "EMAIL_FAILURE";

export const EMAIL_HTML_REQUEST = "EMAIL_HTML_REQUEST";
export const EMAIL_HTML_SUCCESS = "EMAIL_HTML_SUCCESS";
export const EMAIL_HTML_FAILURE = "EMAIL_HTML_FAILURE";

export const EMAIL_SEND_REQUEST = "EMAIL_SEND_REQUEST";
export const EMAIL_SEND_SUCCESS = "EMAIL_SEND_SUCCESS";
export const EMAIL_SEND_FAILURE = "EMAIL_SEND_FAILURE";

export const EMAIL_UPLOAD_TRANSLATIONS_REQUEST =
  "EMAIL_UPLOAD_TRANSLATIONS_REQUEST";
export const EMAIL_UPLOAD_TRANSLATIONS_SUCCESS =
  "EMAIL_UPLOAD_TRANSLATIONS_SUCCESS";
export const EMAIL_UPLOAD_TRANSLATIONS_FAILURE =
  "EMAIL_UPLOAD_TRANSLATIONS_FAILURE";

export const EMAIL_CLEAR_TRANSLATIONS_REQUEST =
  "EMAIL_CLEAR_TRANSLATIONS_REQUEST";
export const EMAIL_CLEAR_TRANSLATIONS_SUCCESS =
  "EMAIL_CLEAR_TRANSLATIONS_SUCCESS";
export const EMAIL_CLEAR_TRANSLATIONS_FAILURE =
  "EMAIL_CLEAR_TRANSLATIONS_FAILURE";

export const EMAILS_REQUEST = "EMAILS_REQUEST";
export const EMAILS_SUCCESS = "EMAILS_SUCCESS";
export const EMAILS_FAILURE = "EMAILS_FAILURE";

export const EMAIL_UPDATE_REQUEST = "EMAIL_UPDATE_REQUEST";
export const EMAIL_UPDATE_SUCCESS = "EMAIL_UPDATE_SUCCESS";
export const EMAIL_UPDATE_FAILURE = "EMAIL_UPDATE_FAILURE";

export const EMAIL_MODULE_LIST_REQUEST = "EMAIL_MODULE_LIST_REQUEST";
export const EMAIL_MODULE_LIST_SUCCESS = "EMAIL_MODULE_LIST_SUCCESS";
export const EMAIL_MODULE_LIST_FAILURE = "EMAIL_MODULE_LIST_FAILURE";

export const EMAIL_MODULE_REQUEST = "EMAIL_MODULE_REQUEST";
export const EMAIL_MODULE_SUCCESS = "EMAIL_MODULE_SUCCESS";
export const EMAIL_MODULE_FAILURE = "EMAIL_MODULE_FAILURE";

export const EMAIL_MODULES_REQUEST = "EMAIL_MODULES_REQUEST";
export const EMAIL_MODULES_SUCCESS = "EMAIL_MODULES_SUCCESS";
export const EMAIL_MODULES_FAILURE = "EMAIL_MODULES_FAILURE";

export const EMAIL_MODULE_UPDATE_REQUEST = "EMAIL_MODULE_UPDATE_REQUEST";
export const EMAIL_MODULE_UPDATE_SUCCESS = "EMAIL_MODULE_UPDATE_SUCCESS";
export const EMAIL_MODULE_UPDATE_FAILURE = "EMAIL_MODULE_UPDATE_FAILURE";

export const EMAIL_MODULE_UPDATE_NAME_VALUE = "EMAIL_MODULE_UPDATE_NAME_VALUE";
export const EMAIL_TEMPLATE_UPDATE_NAME_VALUE =
  "EMAIL_TEMPLATE_UPDATE_NAME_VALUE";

export const EMAIL_MODULE_SET_KEY_VALUE = "EMAIL_MODULE_SET_KEY_VALUE";
export const EMAIL_TEMPLATE_SET_KEY_VALUE = "EMAIL_TEMPLATE_SET_KEY_VALUE";

// Module Editor
export const EDIT_MODULE_TOGGLE_HTML = "EDIT_MODULE_TOGGLE_HTML";
export const EDIT_MODULE_TOGGLE_CSS = "EDIT_MODULE_TOGGLE_CSS";
export const EDIT_MODULE_TOGGLE_DATA = "EDIT_MODULE_TOGGLE_DATA";
export const EDIT_MODULE_TOGGLE_TEMPLATE = "EDIT_MODULE_TOGGLE_TEMPLATE";
export const EDIT_MODULE_TOGGLE_PREVIEW = "EDIT_MODULE_TOGGLE_PREVIEW";
export const EDIT_MODULE_TOGGLE_IMAGEPICKER = "EDIT_MODULE_TOGGLE_IMAGEPICKER";

// Template Editor
export const EMAIL_TEMPLATE_REQUEST = "EMAIL_TEMPLATE_REQUEST";
export const EMAIL_TEMPLATE_SUCCESS = "EMAIL_TEMPLATE_SUCCESS";
export const EMAIL_TEMPLATE_FAILURE = "EMAIL_TEMPLATE_FAILURE";

export const EMAIL_TEMPLATES_REQUEST = "EMAIL_TEMPLATES_REQUEST";
export const EMAIL_TEMPLATES_SUCCESS = "EMAIL_TEMPLATES_SUCCESS";
export const EMAIL_TEMPLATES_FAILURE = "EMAIL_TEMPLATES_FAILURE";

export const EMAIL_TEMPLATE_UPDATE_REQUEST = "EMAIL_TEMPLATE_UPDATE_REQUEST";
export const EMAIL_TEMPLATE_UPDATE_SUCCESS = "EMAIL_TEMPLATE_UPDATE_SUCCESS";
export const EMAIL_TEMPLATE_UPDATE_FAILURE = "EMAIL_TEMPLATE_UPDATE_FAILURE";

export const IMAGE_UPLOAD_REQUEST = "IMAGE_UPLOAD_REQUEST";
export const IMAGE_UPLOAD_SUCCESS = "IMAGE_UPLOAD_SUCCESS";
export const IMAGE_UPLOAD_FAILURE = "IMAGE_UPLOAD_FAILURE";
export const EDITOR_UPLOAD_MODULE_FIELD_VALUE =
  "EDITOR_UPLOAD_MODULE_FIELD_VALUE";

export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";

export const SET_CLIENT_INDEX = "SET_CLIENT_INDEX";

export const QA_REGISTER_TEST = "QA_REGISTER_TEST";
export const QA_FLUSH_TESTS = "QA_FLUSH_TESTS";
export const QA_TEST_PASS = "QA_TEST_PASS";
export const QA_TEST_FAIL = "QA_TEST_FAIL";

export const IMAGES_REQUEST = "IMAGES_REQUEST";
export const IMAGES_SUCCESS = "IMAGES_SUCCESS";
export const IMAGES_FAILURE = "IMAGES_FAILURE";

export const QA_REQUEST = "QA_REQUEST";
export const QA_SUCCESS = "QA_SUCCESS";
export const QA_FAILURE = "QA_FAILURE";

export const EMAIL_DOWNLOAD = "EMAIL_DOWNLOAD";

export const CAMPAIGN_REQUEST = "CAMPAIGN_REQUEST";
export const CAMPAIGN_SUCCESS = "CAMPAIGN_SUCCESS";
export const CAMPAIGN_FAILURE = "CAMPAIGN_FAILURE";
